'use client'

// Bootstraps the local-first sync engine (utils/sync/engine.js) and links it
// to the Steam session already resolved by AuthContext. Deliberately does NOT
// fetch /api/auth/me itself — reuses AuthContext's `user`, per
// docs/ARQUITECTURA-ONLINE.md §5. Mount this right below AuthProvider in
// app/layout.providers.js.

import { useEffect, useRef } from 'react'
import { useAuth } from './AuthContext'
import { initSyncEngine, linkAccount, unlinkAccount } from '@/utils/sync/engine'

export function SyncProvider({ children }) {
    const { user, loading } = useAuth()
    const linkedUserIdRef = useRef(null)

    // Starts the debounced-push / periodic-pull timers once; stays in
    // "disabled" status until linkAccount() is called below.
    useEffect(() => {
        initSyncEngine()
    }, [])

    useEffect(() => {
        if (loading) return

        if (user?.id) {
            if (linkedUserIdRef.current !== user.id) {
                linkedUserIdRef.current = user.id
                void linkAccount(user.id)
            }
        } else if (linkedUserIdRef.current !== null) {
            linkedUserIdRef.current = null
            unlinkAccount()
        }
    }, [user, loading])

    return children
}
